import {
  Table,
  TableCellProps,
  TableColumnHeaderProps,
  TextProps,
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { MText } from '../Monetize';

export const TableCell = ({
  children,
  textProps,
  ...rest
}: { textProps?: TextProps; children: ReactNode } & TableCellProps) => {
  return (
    <Table.Cell borderBottom="none" {...rest}>
      {typeof children !== 'object' ? (
        <MText {...textProps}>{children}</MText>
      ) : (
        children
      )}
    </Table.Cell>
  );
};

export const TableColumnHeader = ({
  children,
  ...rest
}: { children: ReactNode } & TableColumnHeaderProps) => {
  return (
    <Table.ColumnHeader
      fontSize="xs"
      fontWeight="600"
      color="tGray.darkPurple"
      textTransform="uppercase"
      borderBottom="1px solid #e4e4e4"
      borderLeft="none !important"
      {...rest}
    >
      {children}
    </Table.ColumnHeader>
  );
};
